<template>
  <div class="msg-box">
    <h2 class="msg-title">{{title}}</h2>
    <ul class="msg" v-for="(item, index) in tips" :key="index">
      <li v-html="item"></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    title: "",
    tips: Array,
  },
};
</script>
<style lang="less" scoped>
.content {
  .msg-box {
    .msg-title {
      font-weight: bold;
      color: #232323;
      line-height: 54px;
      font-size: 38px;
      margin-top: -15px;
    }
    .msg {
      font-size: 28px;
      line-height: 44px;
      text-align: left;
      margin-top: 35px;
      margin-left: -20px;

      font-weight: 500;
      color: #4a4e53;
      border-radius: 4px;
      background: #eff2f6;
      li {
        &::before {
          content: "";
          display: inline-block;
          margin: 0 10px 10px -20px;
          width: 12px;
          height: 12px;
          vertical-align: middle;
          border-radius: 50%;
          background-color: grey;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/message/src/content/showTips.vue